import { Button, DialogActions, DialogContentText, Divider, Typography } from '@material-ui/core';
import { ButtonVariantEnum } from 'enums/buttonVariant';
import React, { Component, Fragment } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { CustomDialogButtonContainer, CustomDialogContent } from '../CustomDialog.styled';

interface IProps {
  onClose: ((response: ButtonVariantEnum) => void) | undefined;
}

type PropType = IProps & WithTranslation;

class InTranslation extends Component<PropType> {
  private handleClose = (reason: ButtonVariantEnum) => (): void => {
    const { onClose } = this.props;

    if (onClose) {
      onClose(reason);
    }
  };

  render(): JSX.Element {
    const { t } = this.props;
    return (
      <Fragment>
        <CustomDialogContent>
          <DialogContentText>
            <Typography component="span" color="textPrimary">
              {t('modal.inTranslationAlert1')}
            </Typography>
            <br />
            <Typography component="span" color="textPrimary">
              {t('modal.inTranslationAlert2')}
            </Typography>
          </DialogContentText>
        </CustomDialogContent>
        <Divider />
        <DialogActions>
          <CustomDialogButtonContainer>
            <Button color="secondary" variant="contained" onClick={this.handleClose(ButtonVariantEnum.SEND)}>
              {t('modal.createNew')}
            </Button>
            <Button variant="outlined" onClick={this.handleClose(ButtonVariantEnum.UPDATE)}>
              {t('modal.update')}
            </Button>
            <Button variant="outlined" onClick={this.handleClose(ButtonVariantEnum.QUIT)}>
              {t('common.cancel')}
            </Button>
          </CustomDialogButtonContainer>
        </DialogActions>
      </Fragment>
    );
  }
}

export default withTranslation()(InTranslation);
